import { PreIPOEnquiresReducerStateType } from '@modules/pre-ipo-deals/pre-ipo-deals-section/types';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'dateOfEnquiry',
  clearPage: true,
  totalCount: 0,
  date: null,
  status: 'all',
  deals: '',
  selectedUsers: [],
  updateSharePriceClicked: false,
  markAsCompletedClicked: false,
  droppedOffClicked: false,
  closedClicked: false
} as PreIPOEnquiresReducerStateType;

export const preIPOEnquiresClosedListStateReducerSlice = createSlice({
  name: 'preIPOEnquiresClosedListStateReducer',
  initialState,
  reducers: {
    resetPreIPOEnquiresClosedListStateReducerValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'dateOfEnquiry',
      totalCount: 0,
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: [],
      updateSharePriceClicked: false,
      markAsCompletedClicked: false,
      droppedOffClicked: false,
      closedClicked: false
    }),
    updatePreIPOEnquiresClosedListStateReducerValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    resetPreIPOEnquiresClosedFiltersStateReducerValues: state => ({
      ...state,
      search: '',
      date: null,
      status: 'all',
      deals: '',
      selectedUsers: []
    })
  }
});

export const {
  resetPreIPOEnquiresClosedListStateReducerValues,
  updatePreIPOEnquiresClosedListStateReducerValues,
  resetPreIPOEnquiresClosedFiltersStateReducerValues
} = preIPOEnquiresClosedListStateReducerSlice.actions;

export default preIPOEnquiresClosedListStateReducerSlice.reducer;
